import React from 'react'
import Heading from './heading'
import Row, { Slot } from './row'
import ProgressCircle from './progress-circle'
import Bubble from './bubble'
import styles from '../component-styles/score.module.scss'
import Button from './button'
import Tick from '../svgs/tick'
import Cross from '../svgs/cross'

interface Props {
  percentage: number
  failed: number
  passed: number
  toggleActive: () => void
}

export default function Score({
  percentage,
  failed,
  passed,
  toggleActive,
}: Props): React.ReactElement {
  return (
    <section className={styles.container}>
      <Row
        align="flex-start"
        vAlign="center"
        className={styles.mobileOverwrite}
      >
        <Slot width={150}>
          <Heading type={3} align="left">
            Audit score
          </Heading>
          <p>
            <Tick
              className={styles.marker}
              style={{
                fill: '#0FC3F0',
              }}
            />
            {passed} Tests passed
          </p>
          <p>
            <Cross
              className={styles.marker}
              style={{
                fill: '#E61969',
              }}
            />
            {failed} Tests failed
          </p>
        </Slot>
        <Slot width={130}>
          <ProgressCircle percentage={percentage} heightWidth={100} />
        </Slot>
        <div className={styles.slotMobileOverwrite}>
          <Slot padding="0 20px 0 0">
            <Bubble>
              <Row vAlign="center">
                <Slot>
                  <p>
                    We recommend a score of 70% to give you better
                    recommendations.
                  </p>
                  <p>
                    You have {failed} issues to fix, expand each test to find
                    out how.
                  </p>
                </Slot>
              </Row>
            </Bubble>
          </Slot>
          <Slot width={180}>
            <Button onClick={toggleActive}>Request an expert</Button>
          </Slot>
        </div>
      </Row>
    </section>
  )
}
